module.exports = __webpack_public_path__ + "img/淘金币示例图.edf24608.jpeg";